import * as Yup from 'yup';
import '../config/yup';

export default Yup.object().shape({
  login: Yup.string().required(),
  password: Yup.string().required(),
});
